module.exports = __webpack_public_path__ + "static/media/CV_LuisBoscan_ES.9697f622.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/CV_LuisBoscan_ES.pdf
// module id = 383
// module chunks = 0